module.exports = __webpack_public_path__ + "static/img/200085.8a13d3c7.png";